import React, { memo } from 'react'

import {
  Button,
  Icon,
  Download2,
  Book2,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const guideLinkAttrs = { target: '_blank', rel: 'noopener noreferrer' }
const downloadIcon = <Icon svgComponent={Download2} color="dark" size="small" notSpaced />
const guideIcon = <Icon svgComponent={Book2} color="dark" size="small" notSpaced />

function DccRowSubmenu({ downloadUrl = undefined, version = undefined, guideLink = undefined }) {
  const t = useTranslation()

  return (
    <ul className="dcc-bridge-popover__submenu">
      {downloadUrl && (
        <li>
          <Button
            href={downloadUrl}
            aria-label={version ? `Download plugin (v${version})` : 'Download plugin'}
            icon={downloadIcon}
            type="ghost"
            size="small"
            variant="with-icon"
            customClass="dcc-bridge-popover__submenu-link cgt-body-base-semibold"
          >
            {t('footerActions.dccBridge.downloadPluginButton')}
            {version && <span className="dcc-bridge-popover__submenu-version">{`v${version}`}</span>}
          </Button>
        </li>
      )}
      {guideLink && (
        <li>
          <Button
            href={guideLink}
            linkAttributes={guideLinkAttrs}
            icon={guideIcon}
            type="ghost"
            size="small"
            variant="with-icon"
            customClass="dcc-bridge-popover__submenu-link"
          >
            {t('footerActions.dccBridge.guide')}
          </Button>
        </li>
      )}
    </ul>
  )
}

DccRowSubmenu.propTypes = {
  downloadUrl: string,
  version: string,
  guideLink: string,
}

export default memo(DccRowSubmenu)
